import $ from 'jquery';
import whatInput from 'what-input';

window.$ = $;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


/*
* Loding
*/
$(window).bind("load", function() {
   $('header.page-header').find('nav').addClass('loaded');
});

$(document).foundation();

/**** Script *****/
/*
* Global Navi
*/
// ハンバーガーボタン
$('.humberger-icon').click(function(){
	$(this).toggleClass('open');
	$('header.page-header').toggleClass('menu-open');
});

// entry buttonクリック後にメニューが開いていたら閉じる
$('#entry-button').click(function(){
	var page_heaer = $('header.page-header');
	if( page_heaer.hasClass('menu-open') ) {
		page_heaer.find('nav.loaded').hide();
		$('.humberger-icon').toggleClass('open');
		page_heaer.toggleClass('menu-open');
	}
});

/*
* Smooth Scroll
*/
$('a[href^="#"]').click(function(){
	var speed = 500;
	var href= $(this).attr("href");
	var target = $(href == "#" || href == "" ? 'html' : href);
	var position = target.offset().top;
	$("html, body").animate({scrollTop:position}, speed, "swing");
	return false;
});

/*
* トップページのScrollをスクロール後に非表示にする
*/
$(window).scroll(function(){
	var scr_count = $(document).scrollTop();
	var scrolled = 400;
	if ( scr_count > scrolled) {
		$('.scroll').addClass('scrolled');
	} else {
		$('.scroll').removeClass('scrolled');
	}
});

/*
* Scheduleページの最後のcircleにクラスを付与
*/
if($('body.schedule').length) {
	$('.circle').last().addClass('last-child');
}

/*
* グローバルメニューの子要素がある親リンクはクリックを無効
*/
$('ul.menu').find('a.disabled').each(function(){
	$(this).click(function(e){
		e.preventDefault();
	})
});

/*
* アンケートページでIEのみsvgバグがあるためpngへ変更
*/
if($('body.questionnaire').length) {
	if (
		/MSIE 10/i.test(navigator.userAgent) || // internet explorer 10
		/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || // internet explorer 9 or 11
		/Edge\/\d./i.test(navigator.userAgent) // Microsoft Edge
	) {
		var src = $('img[src$="bnr-questionnaire-1.svg"]').attr('src').replace('svg','png');
		$('img[src$="bnr-questionnaire-1.svg"]').attr('src', src);	
	}
}

/*
* back-to-top ボタン
*/
$(window).scroll(function () {
	if ($(this).scrollTop() > 300) {
		$('#back-to-top').fadeIn();
	} else {
		$('#back-to-top').fadeOut();
	}
});

$('#back-to-top a').click(function() {
	$('body,html').animate({
		scrollTop: 0
	}, 800);
	return false;
});
